import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnInit,
} from '@angular/core';
import { FlexLayoutType } from '../../constants/flex-layout.type';
import { NgxFileDropComponent } from 'ngx-file-drop';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { formatBytes } from '../../utils/format-bytes';
import { DocumentUploadStatus } from '../../constants/document-upload-status.type';
import { FormBuilder } from '@angular/forms';
import { PropertyErrorModel } from '../../models/property-error.model';
@Component({
  selector: 'jsg-single-file-uploader',
  templateUrl: './single-file-uploader.component.html',
  styleUrls: ['./single-file-uploader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JsgSingleFileUploaderComponent implements OnInit {
  @ViewChild(NgxFileDropComponent, { static: false })
  ngxFileDropComponent: NgxFileDropComponent;
  @Output() selectFile = new EventEmitter<NgxFileDropEntry>();

  @Input() multiple: boolean = false;
  @Input() acceptedFileTypes: string[];
  @Input() errors: PropertyErrorModel[] = [];

  public maxDate = new Date();
  public FlexLayoutType = FlexLayoutType;
  public DocumentUploadStatus = DocumentUploadStatus;
  public formatBytes = formatBytes;

  public showMaxFileCountError: boolean = false;

  constructor(private fb: FormBuilder) {
    this.showMaxFileCountError = false;
  }

  ngOnInit() {}

  public onChooseFileClick = () => {
    this.ngxFileDropComponent.openFileSelector();
  };

  public fileDropped = (files: NgxFileDropEntry[]) => {
    if (files.length == 1 && files[0].fileEntry.isFile) {
      const file = files[0];
      const fileExt = file.fileEntry.name.split('.').pop();
      if (this.acceptedFileTypes.includes('.' + fileExt)) {
        this.errors = [];
        this.selectFile.emit(file);
      } else {
        this.errors.push(
          new PropertyErrorModel({
            message: "Only PDF's are accepted.",
          })
        );
      }
    } else {
      this.errors.push(
        new PropertyErrorModel({
          message: 'Only one file is allowed to be uploaded.',
        })
      );
    }
  };
}
